import React from 'react';
import EcontextOutcome from 'app/components/OrderPayment/Econtext/EcontextOutcome';

const EcontextResultMob = () => {
  return <EcontextOutcome />;
};

export default EcontextResultMob;
